<template>
    <li
        :class="[
            'SideNavHeader',
            open && 'SideNavHeader--open'
        ]"
    >
        <button
            v-if="open"
            class="SideNavHeader__logo"
            role="tab"
            @click="$emit('navigate', {path: homeUrl})"
        >
            <FullLogo />
        </button>
        <button
            role="tab"
            class="SideNavHeader__container"
            @click="$emit('toggle-open', !open)"
        >
            <CollapsedIcon
                v-if="open"
                class="SideNavHeader__collapse"
            />
            <StreamlineIcon
                v-else
                class="SideNavHeader__menu"
                :icon="NavigationMenu"
                :stroke="white"
                :size="20"
            />
        </button>
    </li>
</template>

<script>
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import FullLogo from '../../../../images/logo/white-full-name.svg';
import CollapsedIcon from '../../../../images/custom/collapse-menu-custom.svg';
import {NavigationMenu} from "@reviewpush/streamline-regular/lib/interface-essential/Menu";
import {white} from 'style/_colors.scss';

export default {
    name: "SideNavHeader",
    components: {
        FullLogo,
        CollapsedIcon,
        StreamlineIcon,
    },
    props: {
        homeUrl: {
            type: String,
            required: true,
        },
        open: {
            type: Boolean,
            required: true,
        }
    },
    data() {
        return {
            NavigationMenu,
            white
        };
    },
};
</script>

<style lang="scss">
.SideNavHeader {
    height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;

    &--open {
        padding: 0 1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    &__logo,
    &__container {
        display: flex;
        border-radius: 4px;
    }
    &__collapse{
        margin-left: 1rem;
    }
    &__menu {
        padding: 0.5rem;
        border-radius: 4px;
        opacity: .7;
        &:hover {
            background: $highlight-blue;
        }
    }
}
</style>